import $ from 'jquery';

const defaults = {
  fade: true,
  speed: 500,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        fade: false,
        speed: 200,
      },
    },
  ],
};

export default class StoriesSlider {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = { ...defaults, ...options };
    this.slider = this.createSlider();
    this.ready();
  }

  createSlider() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}



// WEBPACK FOOTER //
// ./StoriesSlider.js